import React from "react";
import { UserProvider } from "../../../contexts/UserContext";
import { ServiceProvider } from "../../../contexts/ServiceContext";
import { SideBar } from "../../components/top-level/sidebar/SideBar";
import { Outlet } from "react-router-dom";
import { Footer } from "../../components/top-level/footer/Footer";
import { PrivilegesGuard } from "./NoPrivileges/NoPrivileges";
import { ToastProvider } from "../../../contexts/ToastContext";
import { ResourceProvider } from "../../../contexts/ResourceContext";
import { ApplicationScreen } from "../../components/top-level/screen/ApplicationScreen";

export function PrivateAppRoot() {
    return (
        <ToastProvider>
            <UserProvider>
                <ServiceProvider>
                    <ResourceProvider>
                        <ApplicationScreen>
                            <PrivilegesGuard>
                                <SideBar />
                                <div className={"flex-1"}>
                                    <div
                                        className={
                                            "w-full flex flex-col min-h-content px-64 pt-64"
                                        }
                                    >
                                        <Outlet />
                                    </div>
                                    <Footer />
                                </div>
                            </PrivilegesGuard>
                        </ApplicationScreen>
                    </ResourceProvider>
                </ServiceProvider>
            </UserProvider>
        </ToastProvider>
    );
}
